import React, { Fragment, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Splitter } from "@progress/kendo-react-layout";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import {
  getStatusText,
  gotoGlobalView,
} from "../../redux/slices/migrationspageslice";
import { Checkbox } from "@progress/kendo-react-inputs";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  ToolbarSpacer,
  Button,
  DropDownButton,
} from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { DropDownListById } from "../../forms/form-components";
import { Form } from "../../components/form";
import { List } from "../../components/list";
import { Input } from "@progress/kendo-react-inputs";
import { MigrationsPageForm } from "./migrationspageform";
import { MyGrid } from "../../components/mygrid";
import { IntroPage } from "../intropage";
import { HelpPage } from "../helppage";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

const planItemRender = (li, itemProps) => {
  let itemIcon = "";

  if (itemProps.dataItem.Id == 0)
    //none
    itemIcon = "minus";
  // else if (itemProps.dataItem.CategoryId == 2)//view
  //   itemIcon = "group";
  // else if (itemProps.dataItem.CategoryId == 3)//SP
  //   itemIcon = "html";
  //
  else itemIcon = "group";

  const itemChildren = (
    <div
      className="plans-list-item"
      style={{ display: "flex", alignItems: "center", padding: "0px 6px" }}
    >
      <div
        style={{
          marginRight: 12,
        }}
        className={`k-icon k-i-${itemIcon}`}
      ></div>
      <div>{itemProps.dataItem.Title}</div>
    </div>
  );

  return React.cloneElement(li, li.props, itemChildren);
};

const isModel = (currentUser) =>
  currentUser &&
  currentUser.IsAuthenticated &&
  currentUser.Subscription?.Name?.toLowerCase() === "model";

const toolbarRenderer = (props) => {
  const { currentTheme, currentUser, pageState, t } = props;

  const currentMigration = pageState.formValues;

  const saveTitle =
    pageState.mode == 1 ? t("migrations.save_mig") : t("migrations.update_mig");

  const activateTitle =
    pageState.mode != 2
      ? ""
      : currentMigration.IsActive
      ? t("migrations.deactivate_mig")
      : t("migrations.activate_mig");

  let isActive = currentMigration && currentMigration.IsActive;
  let activateIcon =
    pageState.mode != 2
      ? ""
      : currentMigration.IsActive
      ? t("migrations.close")
      : t("migrations.check");

  return (
    <Toolbar>
      {currentUser.IsAuthenticated &&
        currentUser.Extras?.Migrations?.CanCreateResolved && (
          <ToolbarItem>
            <Button
              disabled={pageState.processing}
              style={{ color: currentTheme.primary }}
              icon="plus"
              onClick={props.onNew}
            >
              {t("migrations.create")}
            </Button>
          </ToolbarItem>
        )}
      {currentUser.IsAuthenticated &&
        ((pageState.mode == 1 &&
          currentUser.Extras?.Migrations?.CanCreateResolved) ||
          (pageState.mode == 2 &&
            currentUser.Extras?.Migrations?.CanEditResolved)) && (
          <Fragment>
            <ToolbarSeparator />
            <ToolbarItem>
              <Button
                disabled={pageState.processing}
                style={{ color: currentTheme.primary }}
                icon="save"
                onClick={props.onSave}
              >
                {saveTitle}
              </Button>
            </ToolbarItem>
          </Fragment>
        )}
      {currentUser.IsAuthenticated &&
        pageState.mode == 2 &&
        currentUser.Extras?.Migrations?.CanEditResolved && (
          <Fragment>
            <ToolbarSeparator />
            <ToolbarItem>
              <Button
                disabled={pageState.processing}
                style={{ color: currentTheme.primary }}
                icon={activateIcon}
                onClick={isActive ? props.onDeactivate : props.onActivate}
              >
                {activateTitle}
              </Button>
            </ToolbarItem>
          </Fragment>
        )}
      {currentUser.IsAuthenticated &&
        pageState.mode == 2 &&
        currentUser.Extras?.Migrations?.CanApplyResolved &&
        currentMigration &&
        (currentMigration.Status == null || currentMigration.Status == -1) && (
          <Fragment>
            <ToolbarSeparator />
            <ToolbarItem>
              <Button
                disabled={pageState.processing}
                style={{ color: currentTheme.primary }}
                icon="attachment"
                onClick={props.onApply}
              >
                {t("migrations.apply")}
              </Button>
            </ToolbarItem>
          </Fragment>
        )}
      {currentUser.IsAuthenticated &&
        pageState.mode == 2 &&
        currentUser.Extras?.Migrations?.CanApplyResolved &&
        currentMigration &&
        currentMigration.Status == 0 && (
          <Fragment>
            <ToolbarSeparator />
            <ToolbarItem>
              <Button
                disabled={pageState.processing}
                style={{ color: currentTheme.primary }}
                icon="attachment-45"
                onClick={props.onReapply}
              >
                {t("migrations.reapply")}
              </Button>
            </ToolbarItem>
          </Fragment>
        )}
      {pageState.mode == 2 &&
        currentUser.IsAuthenticated &&
        currentUser.Extras?.Migrations?.CanDeleteResolved && (
          <Fragment>
            <ToolbarSeparator />
            <ToolbarItem>
              <Button
                disabled={
                  pageState.processing ||
                  !currentMigration ||
                  currentMigration.Status == 0 ||
                  currentMigration.Status == 1
                }
                style={{ color: currentTheme.primary }}
                icon="delete"
                onClick={(e) => props.onDelete(null)}
              >
                {t("migrations.delete")}
              </Button>
            </ToolbarItem>
          </Fragment>
        )}
    </Toolbar>
  );
};

const getEntityOperations = (migration, currentUser, t) => {
  let result = [];

  if (
    currentUser.IsAuthenticated &&
    (currentUser.Extras?.Migrations?.CanViewResolved ||
      currentUser.Extras?.Migrations?.CanEditResolved)
  )
    result.push({ id: 2, text: t("migrations.view"), icon: "eye" });

  if (
    currentUser.IsAuthenticated &&
    currentUser.Extras?.Migrations?.CanDeleteResolved
  )
    result.push({ id: 3, text: t("migrations.delete1"), icon: "delete" });

  return result;
};

const entityMenuItemRenderer =
  (currentTheme, migrationId, onItemClicked) => (props) => {
    if (props.item.text)
      return (
        <div
          style={{ display: "flex", width: "100%", padding: "0px 6px" }}
          onClick={(e) => onItemClicked(migrationId, props.item)}
        >
          <span
            className={`k-icon k-i-${props.item.icon}`}
            style={{ display: "inline-block" }}
          ></span>
          <div style={{ marginLeft: 12 }}>{props.item.text}</div>
        </div>
      );
    else return <div className="menu-separator" style={{}} />;
  };

const entitiesItemRenderer =
  (currentTheme, currentUser, t) => (props, item, index) => {
    //items are always visible in the left-hand list;  the Edit/Delete item menu appear based on the permission and so for double click
    return (
      <div
        key={item.Id}
        className={`list-item`}
        onDoubleClick={(e) => {
          if (
            currentUser.IsAuthenticated &&
            (currentUser.Extras?.Migrations?.CanViewResolved ||
              currentUser.Extras?.Migrations?.CanEditResolved)
          )
            props.onMigrationDoubleClick(item.Id);
        }}
      >
        <div
          className={`list-item-migration-icon k-icon k-i-group`}
          style={{ marginLeft: 8 }}
        ></div>
        <div className="list-item-title">{item.Name}</div>
        {currentUser.IsAuthenticated &&
          (currentUser.Extras?.Migrations?.CanViewResolved ||
            currentUser.Extras?.Migrations?.CanEdit ||
            currentUser.Extras?.Migrations?.CanDeleteResolved) && (
            <div className="list-item-operations">
              <DropDownButton
                className="buttons-container-button"
                items={getEntityOperations(item, currentUser, t)}
                itemRender={entityMenuItemRenderer(
                  currentTheme,
                  item.Id,
                  (migrationId, _item) => {
                    if (_item.id == 1 || _item.id == 2)
                      //view
                      props.onEntitySelected(migrationId, _item);
                    else if (_item.id == 3)
                      // delete
                      props.onDelete(migrationId, _item);
                  }
                )}
                icon="more-horizontal"
                fillMode={"flat"}
              />
            </div>
          )}
      </div>
    );
  };

const getGlobalHistory = (plan, t) => {
  let schema = [
    { id: "status", dataType: 2, title: t("migrations.status"), hidden: true },
    { id: "statusText", dataType: 3, title: t("migrations.status") },
    { id: "migrationId", dataType: 2, title: t("migrations.id"), hidden: true },
    { id: "migrationName", dataType: 3, title: t("migrations.migration") },
    { id: "version", dataType: 2, title: t("migrations.version") },
    { id: "alerts", dataType: 3, title: "", hidden: true },
    {
      id: "alertsSummary",
      dataType: 3,
      title: t("migrations.alerts"),
      tooltip: (obj) => obj.alerts,
    },
    { id: "reports", dataType: 2, title: "", hidden: true },
    {
      id: "reportsSummary",
      dataType: 2,
      title: t("migrations.reports"),
      tooltip: (obj) => obj.reports,
    },
  ];

  let data = [];

  let result = {
    schema: schema,
    data: [],
  };

  if (!plan || !plan.Migrations || plan.Migrations.length == 0) return result;

  for (let m of plan.Migrations) {
    let alerts = "",
      alertsSummary = "",
      reports = "",
      reportsSummary = "";

    let alertsArr = m.Entities.filter((e) => e.EntityTypeId == 1);
    if (alertsArr && alertsArr.length > 0) {
      for (let e of alertsArr) alerts += e.EntityTitle + ", ";

      alertsSummary =
        alerts.length > 120 ? alerts.substring(0, 120) + "..." : alerts;
      alerts = alerts.substring(0, alerts.length - 2).replaceAll(", ", "\r\n");
    }

    let reportsArr = m.Entities.filter((e) => e.EntityTypeId == 2);
    if (reportsArr && reportsArr.length > 0) {
      for (let e of reportsArr) reports += e.EntityTitle + ", ";

      reportsSummary =
        reports.length > 120 ? reports.substring(0, 120) + "..." : reports;
      reports = reports
        .substring(0, reports.length - 2)
        .replaceAll(", ", "\r\n");
    }

    result.data.push({
      status: m.Status,
      statusText: getStatusText(m.Status),
      migrationId: m.Id,
      migrationName: m.Name,
      version: m.Version,
      alerts: alerts,
      alertsSummary: alertsSummary,
      reports: reports,
      reportsSummary: reportsSummary,
    });
  }

  return result;
};

export const MigrationsPageBody = (props) => {
  const {
    onSplitterChange,
    plansPanelRef,
    onPlanChange,
    onNew,
    onSave,
    onActivate,
    onDeactivate,
    onApply,
    onReapply,
    onDelete,
    onErrorbarClose,
    onEntitySelected,
    onMigrationDoubleClick,
    introItems,
    helpItems,
    updateDirtyState,
    getStatusText,
    onAlertCheck,
    onReportCheck,
    ...other
  } = props;

  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.currentTheme);
  const currentUser = useSelector((state) => state.currentUser);
  const pageState = useSelector((state) => state.migrationsPage);
  const appearance = useSelector((state) => state.appearance);
  const plans = pageState.lookups.plans;
  const currentPlan = useSelector((state) => state.migrationsPage.currentPlan);
  const currentPlanId = currentPlan.Id;
  const [entityFilter, setEntityFilter] = useState("");

  const currentMigration = pageState.formValues;

  const { t } = useTranslation();

  const getPanelBarItems = () => {
    const panelBarItems = [];

    panelBarItems.push(
      <PanelBarItem
        className="panel-plan"
        key="plan"
        title={t("migrations.plan")}
        expanded={true}
      >
        <div className="plan">
          <DropDownListById
            iconClassName="k-icon k-i-arrow-s k-i-table"
            style={{ marginTop: 4 }}
            data={plans}
            dataItemKey="Id"
            textField="Title"
            value={currentPlanId}
            onChange={onPlanChange}
            itemRender={planItemRender}
          />
          {currentPlanId == 0 && (
            <div
              style={{ marginLeft: 3, color: `${currentTheme.touchColor}` }}
              className="k-form-hint k-text-center"
            >
              {t("migrations.select")}
            </div>
          )}
          {currentPlanId != 0 &&
            (pageState.mode == 1 || pageState.mode == 2) && (
              <div
                style={{ marginLeft: 3, color: `${currentTheme.touchColor}` }}
                className="k-form-hint k-text-center global-view"
                onClick={(e) => dispatch(gotoGlobalView())}
              >
                {t("migrations.global")}
              </div>
            )}
        </div>
      </PanelBarItem>
    );

    if (currentPlan.Id != 0) {
      panelBarItems.push(
        <PanelBarItem
          className="panel-migrations"
          key="migrations"
          title={t("migrations.migrations")}
          selected={false}
          expanded={false}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Input
              type="search"
              value={entityFilter}
              onChange={(e) => setEntityFilter(e.value)}
              style={{
                width: "calc(100% - 16px)",
                margin: "16px 8px 8px 8px",
                backgroundColor: "transparent",
              }}
              placeholder={t("migrations.search")}
            />
            <List
              className="migrations"
              items={currentPlan.Migrations.filter((e) => {
                if (!entityFilter || entityFilter.trim() == "") return true;

                //i am here => there is text
                const filter = entityFilter.toLowerCase();

                return e.Name.toLowerCase().indexOf(filter) >= 0;
              })}
              itemRenderer={entitiesItemRenderer(currentTheme, currentUser, t)}
              onEntitySelected={onEntitySelected}
              onMigrationDoubleClick={onMigrationDoubleClick}
              onDelete={props.onDelete}
            />
          </div>
        </PanelBarItem>
      );
    }

    return panelBarItems;
  };

  let globalHistory = [];

  if (
    pageState.pageLoaded &&
    currentPlanId != 0 &&
    pageState.mode != 1 &&
    pageState.mode != 2
  ) {
    //compute global history only when needed i.e. when the link is displayed
    globalHistory = getGlobalHistory(pageState.currentPlan, t);
  }

  return (
    <Fragment>
      {pageState.processing && (
        <div className="page-loader">
          <Loader
            size={"large"}
            type="infinite-spinner"
            themeColor={"primary"}
          />
          {pageState.processingText && (
            <div style={{ fontSize: 13, color: currentTheme.primary }}>
              {pageState.processingText}
            </div>
          )}
        </div>
      )}
      {pageState.pageLoaded && (
        <Splitter
          style={{ border: "none" }}
          panes={pageState.panes}
          onChange={onSplitterChange}
        >
          <div className="migrations-page-manager">
            <PanelBar
              ref={plansPanelRef}
              style={{ border: "none" }}
              expanded={[".0", ".1"]}
            >
              {getPanelBarItems()}
            </PanelBar>
          </div>
          {currentPlanId != 0 && (
            <Form
              className="migrations-page-form"
              currentTheme={currentTheme}
              currentUser={currentUser}
              toolbarRenderer={toolbarRenderer}
              t={t}
              onNew={onNew}
              onSave={onSave}
              onActivate={onActivate}
              onDeactivate={onDeactivate}
              onApply={onApply}
              onReapply={onReapply}
              onDelete={onDelete}
              errorMessages={pageState.formServerErrors}
              onErrorbarClose={onErrorbarClose}
              pageState={pageState}
            >
              {pageState.mode > 0 ? (
                <MigrationsPageForm
                  updateDirtyState={updateDirtyState}
                  getStatusText={getStatusText}
                  onAlertCheck={onAlertCheck}
                  onReportCheck={onReportCheck}
                />
              ) : (
                <Fragment>
                  <MyGrid
                    className="global-history-grid"
                    currentTheme={currentTheme}
                    schema={globalHistory.schema}
                    data={globalHistory.data}
                    rowStyleHandler={(row) => {
                      if (row.status == -1)
                        return { color: currentTheme.error };
                      else if (row.status == 1)
                        return { color: currentTheme.success };
                      else if (row.status == 0)
                        return { color: currentTheme.warning };
                    }}
                    onRowDoubleClick={(row) => {
                      props.onEntitySelected(row.migrationId);
                    }}
                    isPageable={true}
                    pageSize={100}
                    isFilterable={true}
                    isSortable={true}
                  />
                </Fragment>
              )}
            </Form>
          )}
          {currentPlanId == 0 && (
            <IntroPage
              title={t("migrations.migrations")}
              items={introItems.current}
            />
          )}
        </Splitter>
      )}
      <style>
        {`                  
                    .migrations-page > .content
                    {
                    }

                    .migrations-page .k-splitter{
                      flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }

                    .migrations-page > .content .migrations-page-manager
                    {
                      border: ${currentTheme.managerBorder};
                      border-radius: ${currentTheme.pageBorderRadius};
                      background-color: ${currentTheme.componentBgFaded};
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"};
                    }
                    
                    .migrations-page > .content .migrations-page-manager .k-dropdownlist
                    {
                      /*bg of datasets dropdown*/
                      background-color: transparent;
                      color: ${currentTheme.componentText};
                    }

                    /*.migrations-page .content .migrations-page-manager .k-dropdownlist:focus
                    {
                        box-shadow: none;   
                    }*/

                    .migrations-page > .content .migrations-page-manager .panel-migrations .k-input::placeholder
                    {
                        color: ${currentTheme.componentText};
                        /*font-style: italic;*/
                    }

                    .migrations-page > .content .migrations-page-manager .k-panelbar
                    {
                      /*required*/
                      background-color: transparent;
                    }

                    .migrations-page > .content .migrations-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link .k-icon
                    {
                      /*the arrow near every panel header*/
                      color: ${currentTheme.touchColor}!important;
                      margin-right: 6px;
                    }
                    
                    .migrations-page > .content .migrations-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link
                    {
                      /*the span in the above <li> i.e. the title of every group in the manager: datasets, migrations, columns and description*/  
                      background-color: transparent;
                      color: ${currentTheme.touchColor};
                      border-bottom: 1px solid ${currentTheme.separatorColor}; 
                    }

                    .migrations-page > .content .migrations-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link:hover
                    {
                      /*the above hovered - do nothing*/
                    }

                    .migrations-page > .content .migrations-page-manager .migrations .list-item:hover
                    {
                      /*migration item hover */
                      background-color: ${currentTheme.componentBorderColor};
                      cursor: pointer;
                    }

                    .migrations-page > .content .migrations-page-manager .dataset,
                    .migrations-page > .content .migrations-page-manager .description,
                    .migrations-page > .content .migrations-page-manager .k-child-animation-container
                    {
                      /*bg color of exp. manager elements */
                    }

                    .migrations-page > .content .migrations-page-manager .global-view:hover
                    {
                      cursor: pointer;
                    }

                    .migrations-page > .content .migrations-page-manager .list-container
                    {
                      /*bg of both the exp. and columns Lists*/
                      background-color: transparent;
                      padding : 0;/*can add padding to list items*/
                    }

                    .migrations-page > .content .migrations-page-manager .k-panelbar-header
                    {
                      background-color: transparent;
                    }

                    .migrations-page > .content .migrations-page-manager .k-panelbar-content
                    {
                      background-color: transparent;
                    }

                    .migrations-page > .content .migrations-page-manager .migrations .list-item-data-type-icon
                    {
                      /*first icon in migrations list*/
                      padding-left: 12px
                    }

                    .migrations-page > .content .migrations-page-manager .migrations .list-item-migration-icon
                    {
                      /*second icon in migrations list*/
                      padding: 5px 2px 5px 12px;                 
                    }

                    .migrations-page > .content .migrations-page-manager .migrations .list-item-title
                    {
                      vertical-align: middle;/*fine tuning*/
                    }

                    .migrations-page > .content .migrations-page-manager .columns
                    {
                      /*space above the first column in the list*/
                      padding-top: 6px;
                    }

                    .migrations-page > .content .migrations-page-manager .columns .list-item-data-type-icon
                    {
                      /*first icon in columns list*/
                      padding-left: 12px;
                    }

                    .migrations-page > .content .migrations-page-manager .columns .list-item-title
                    {
                    }                    

                    /*the form*/
                    .migrations-page-form   
                    {
                        background-color: transparent;
                        padding-left: 0px;
                        border: ${currentTheme.pageFormBorder};   
                        border-radius: ${currentTheme.pageBorderRadius};
                    }

                    /*form toolbar*/
                    .migrations-page-form > .toolbar .k-toolbar
                    {
                        width: 100%;
                        border-left: none !important;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                        border-top: none !important;
                        border-right: none !important;
                        background-color: ${
                          currentTheme.toolbarBg
                        };/*transparent;*/
                        direction:${appearance.isRightToLeft ? "rtl" : "ltr"}
                        
                    }

                    .migrations-page > .content .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                    }

                    .migrations-page > .content .toolbar .k-button-text
                    {
                      /*color of the text in every toolbar button=black in azure theme*/
                      color: ${currentTheme.toolbarText};
                    }

                    .migrations-page > .content .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.primary};
                    }

                    .migrations-page > .content .form-root .k-form .k-form-field:nth-child(1)
                    {
                        margin-top: 4px;
                    }

                    .migrations-page > .content .form-root .k-form .k-form-field
                    {
                        margin-top: 32px;
                    }

                    // .migrations-page > .content .form-root .k-form .k-form-field:nth-child(6)                   
                    // {
                    //     margin-top: -4px !important;
                    //     width: 100%;
                    // }

                    .migrations-page > .content .form-root .content
                    {
                      background-color: ${currentTheme.pageContentBg};
                        direction:${appearance.isRightToLeft ? "rtl" : "ltr"}
                    }

                    /*styling the popup menu */
                    .k-popup ul{
                        padding: 0px;
                    }

                    .k-popup ul > li{
                        margin: 0;
                        padding: 0px;                                
                    }

                    .k-popup ul > li > span{
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .k-menu-link{
                        padding: 0px 0px !important;
                        
                    }


                    /* global view grid */
                    .migrations-page-form .global-history-grid
                    {
                        height: 100%;       
                        margin: 18px;                 
                    }

                    .migrations-page-form .global-history-grid .k-filtercell input
                    {
                        padding: 4px 6px;
                    }

                    .migrations-page-form .global-history-grid tr:hover
                    {
                      cursor: pointer;
                    }

                    .migrations-page-form .global-history-grid .k-grid-header col:nth-of-type(1)
                    {
                        width: 12%;
                    }
                    .migrations-page-form .global-history-grid .k-grid-table col:nth-of-type(1)
                    {
                        width: 12%;
                    }

                    .migrations-page-form .global-history-grid .k-grid-header col:nth-of-type(2)
                    {
                        width: 12%;
                    }
                    .migrations-page-form .global-history-grid .k-grid-table col:nth-of-type(2)
                    {
                        width: 12%;
                    }

                    .migrations-page-form .global-history-grid .k-grid-header col:nth-of-type(3)
                    {
                        width: 8%;
                    }
                    .migrations-page-form .global-history-grid .k-grid-table col:nth-of-type(3)
                    {
                        width: 8%;
                    }

                    .migrations-page-form .global-history-grid .k-grid-header col:nth-of-type(4)
                    {
                        width: 34%;
                    }
                    .migrations-page-form .global-history-grid .k-grid-table col:nth-of-type(4)
                    {
                        width: 34%;
                    }

                    .migrations-page-form .global-history-grid .k-grid-header col:nth-of-type(5)
                    {
                        width: 34%;
                    }
                    .migrations-page-form .global-history-grid .k-grid-table col:nth-of-type(5)
                    {
                        width: 34%;
                    }


                    .migrations-page-form .global-history-grid .statusText,
                    .migrations-page-form .global-history-grid .version
                    {
                        text-align: center;
                        justify-content: center;
                    }
                    /* global view grid */
                  `}
      </style>
    </Fragment>
  );
};
